import React from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  Image,
  SimpleGrid,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
//import heroImage from "../../assets/hero-ideas.svg"; // Passe den Pfad zu deinem SVG/PNG an

const Home = () => {
  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-b, teal.50, white)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={{ base: 10, md: 20 }}
    >
      <Container maxW="6xl">
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing={{ base: 8, md: 16 }}
          alignItems="center"
        >
          {/* Text-Content */}
          <VStack align="start" spacing={6}>
            <Heading
              as="h1"
              bgGradient="linear(to-r, teal.500, blue.400)"
              bgClip="text"
              fontSize={{ base: "2xl", md: "4xl" }}
              lineHeight="short"
            >
              Willkommen bei userer Ideenverwaltung
            </Heading>
            <Text fontSize={{ base: "md", md: "lg" }} color="gray.600">
              Erfasse, bearbeite und verfolge deine besten Einfälle — übersichtlich,
              modern und auf allen Geräten nutzbar.
            </Text>

            <VStack align="start" spacing={3}>
              <Button
                as={RouterLink}
                to="/ideen"
                variant="primary"
                size={{ base: "md", md: "lg" }}
              >
                Ideen anzeigen
              </Button>
              <Button
                as={RouterLink}
                to="/ideen/addIdee"
                variant="subtleAccent"
                size={{ base: "md", md: "lg" }}
              >
                Neue Idee hinzufügen
              </Button>
            </VStack>
          </VStack>

          {/* Illustration */}
          <Box display="flex" justifyContent="center">
		  <Image
			  src="https://cdn-icons-png.flaticon.com/512/2729/2729079.png"
			  alt="Ideen Illustration"
			  maxW={{ base: "80%", md: "100%" }}
			  objectFit="contain"
			  borderRadius="2xl"
			  shadow="md"
			/>

           </Box>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default Home;
